<template>
  <form v-if="value" @submit.prevent="onSubmit">
    <form-group label="Nom de la couleur" required>
      <form-input type="text" v-model.trim="model.name" required/>
      <span slot="help">Le nom de la couleur peut vous aider à la retrouver et sert aux personnes ayant des difficultés à distinguer les couleurs.</span>
    </form-group>

    <form-group label="Groupe">
      <form-typeahead v-model="model.group" :dataset="groupColorsDataset" />
      <span slot="help">En regroupant les couleurs par ensemble logique (ex : couleurs d'une collection), cela facilite l'administration des produits.</span>
    </form-group>

    <form-group label="Couleur" required>
      <div class="display-inline-block"><form-color required v-model.trim="mainColor" :options="colorOptions" /></div>
      <div class="display-inline-block ml-10" v-show="isDuo"><form-color required v-model.trim="secondColor" :options="colorOptions" /></div>
      <div class="display-inline-block ml-10"><form-checkbox v-model="isDuo">Bicolore</form-checkbox></div>
    </form-group>

    <hr />

    <slot name="actions"></slot>
  </form>
</template>

<script>
import _map from "lodash/map";
import _omit from "lodash/omit";

import ColorGroupsListQuery from "./graphql/ColorGroupsListQuery.gql";

export default {
  components: {
    FormStickyHeader: () => import("../../components/FormStickyHeader.vue"),
    FormFileUpload: () => import("../../components/FormFileUpload.vue"),
    FormTypeahead: () =>
      import("package-common-vuejs/src/components/form/FormTypeahead"),
    FormSwitch: () =>
      import("package-common-vuejs/src/components/form/FormSwitch"),
    FormColor: () => import("package-common-vuejs/src/components/form/FormColor.vue")
  },
  props: {
    title: String,
    value: Object
  },
  apollo: {
    colorGroups: {
      query: ColorGroupsListQuery,
      fetchPolicy: "network-only",
      update: data =>
        _map(data.results, 'name').filter(x => !!x)
    }
  },
  data() {
    return {
      model: {},

      colorOptions: {
        preferredFormat: "hex",
        showInput: true,
      }
    };
  },
  computed: {
    groupColorsDataset() {
      return {
        source: (query, syncResults, asyncResults) => {
          const lcQuery = (''+query).toLowerCase();
          syncResults(this.colorGroups.filter(groupName => groupName.toLowerCase().indexOf(lcQuery) !== -1));
          asyncResults([]);
        }
      };
    },
    isDuo: {
      get() {
        return this.model.kind === "duo";
      },
      set(value) {
        this.$set(this.model, "kind", value ? "duo" : "");
      }
    },
    mainColor: {
      get() {
        const [mainColor] = this.model.colors || ["#000000"];
        return mainColor;
      },
      set(value) {
        this.$set(
          this.model,
          "colors",
          this.isDuo ? [value, this.secondColor] : [value]
        );
      }
    },
    secondColor: {
      get() {
        const [mainColor, secondaryColor] = this.model.colors || [
          "#000000",
          "#000000"
        ];
        return secondaryColor || mainColor;
      },
      set(value) {
        this.$set(this.model, "colors", [this.mainColor, value]);
      }
    }
  },
  created() {
    this.updateModel(this.value);
  },
  watch: {
    value() {
      this.updateModel(this.value);
    }
  },
  methods: {
    updateModel(value) {
      this.model = {
        ...value,
        group: value && value.group ? value.group.name : ""
      };
    },
    onSubmit() {
      this.$emit(
        "submit",
        _omit(
          {
            ...this.model,
            colors: this.mainColor ? this.model.colors : ["#000000"]
          },
          ["id", "__typename"]
        )
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/colors/ColorForm.vue